export default __webpack_public_path__ + "static/media/illustration-recruit-1-w@3x.b32ededa.webp";